import { render } from "./BeneficiaryRow.vue?vue&type=template&id=e18364ec"
import script from "./BeneficiaryRow.vue?vue&type=script&lang=js"
export * from "./BeneficiaryRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__